import { IPortfolioTopHeroesComponentsList } from 'api/queries/getProjectScoreCardsSummary';
import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

export interface QueryResponse {
    componentsList: IPortfolioTopHeroesComponentsList;
    info?: IToolTip;
    name: string;
    numOfItems: number;
}

export const queryFn = (params) => {
    return network.post('api/bo/getPortfolioTopHeroes', params).then((response) => {
        return response.data;
    });
};
export const useQueryPortfolioTopHeroes = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['portfolioTopHeroes', params],
        queryFn: () => queryFn(params),
    });
};
